<ng-container [formGroup]="parent.entryForm">

<nb-select formControlName="{{field.name}}" fullWidth [selected]="{roleId: 'assistant'}"
[showStatusIconOn]="{ showOnControlStatus: field.statusIconOn ?? ['valid','invalid','pending'], invalidWhen: field.invalidWhen ?? 'touchedOrDirty' }"
status="{{
  !field.required && !parent.entryForm.controls[field.name].touched && !parent.entryForm.controls[field.name].dirty ? 'basic' :
  parent.entryForm.controls[field.name].status == 'VALID' ? 'success' :
  parent.entryForm.controls[field.name].pristine && parent.entryForm.controls[field.name].status == 'INVALID' ? 'warning' : 
  'primary'
}}"  
    placeholder="{{field.label}}" nbPopover="{{field.helpMessage}}" nbPopoverTrigger="noop" nbPopoverContext="{{field.name}}">
    <nb-option *ngFor="let option of field.options" value="{{option.value}}" >{{option.label}}</nb-option>
  </nb-select>
  
</ng-container>